import { DayOfWeekSchema, type DayOfWeek as GeneratedDayOfWeek } from '~/services/api/generated'

// Mirrors backend App\Enums\Store\DayOfWeek — Monday-first order is canonical.

export type DayOfWeek = GeneratedDayOfWeek

export const DayOfWeek = {
  MONDAY: DayOfWeekSchema.enum.monday,
  TUESDAY: DayOfWeekSchema.enum.tuesday,
  WEDNESDAY: DayOfWeekSchema.enum.wednesday,
  THURSDAY: DayOfWeekSchema.enum.thursday,
  FRIDAY: DayOfWeekSchema.enum.friday,
  SATURDAY: DayOfWeekSchema.enum.saturday,
  SUNDAY: DayOfWeekSchema.enum.sunday
} satisfies Record<string, GeneratedDayOfWeek>

export const DayOfWeekValues: readonly GeneratedDayOfWeek[] = [
  DayOfWeekSchema.enum.monday,
  DayOfWeekSchema.enum.tuesday,
  DayOfWeekSchema.enum.wednesday,
  DayOfWeekSchema.enum.thursday,
  DayOfWeekSchema.enum.friday,
  DayOfWeekSchema.enum.saturday,
  DayOfWeekSchema.enum.sunday
]
